<template>
  <div class="right_btn_container">
    <div
        v-if="status === 'list'"
        class="right_add_list_btn pointer right_btn"
        style="margin-bottom:5px;"
        @click="handleClick($event, 'write')"
    >
      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
           v-tooltip="this.$t('status.add')"
           width="22" height="22"
           viewBox="0 0 172 172"
           style=" fill:#000000;">
        <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
           stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
           font-family="none" font-weight="none" font-size="none" text-anchor="none"
           style="mix-blend-mode: normal">
          <path d="M0,172v-172h172v172z" fill="none"></path>
          <g id="original-icon" fill="#275cbb" opacity="0" visibility="hidden">
            <path
                d="M21.5,32.25c-5.93706,0 -10.75,4.81294 -10.75,10.75c0,5.93706 4.81294,10.75 10.75,10.75c5.93706,0 10.75,-4.81294 10.75,-10.75c0,-5.93706 -4.81294,-10.75 -10.75,-10.75zM57.33333,35.83333c-2.58456,-0.03655 -4.98858,1.32136 -6.29153,3.55376c-1.30295,2.2324 -1.30295,4.99342 0,7.22582c1.30295,2.2324 3.70697,3.59031 6.29153,3.55376h93.16667c2.58456,0.03655 4.98858,-1.32136 6.29153,-3.55376c1.30295,-2.2324 1.30295,-4.99342 0,-7.22582c-1.30295,-2.2324 -3.70697,-3.59031 -6.29153,-3.55376zM21.5,75.25c-5.93706,0 -10.75,4.81294 -10.75,10.75c0,5.93706 4.81294,10.75 10.75,10.75c5.93706,0 10.75,-4.81294 10.75,-10.75c0,-5.93706 -4.81294,-10.75 -10.75,-10.75zM57.33333,78.83333c-2.58456,-0.03655 -4.98858,1.32136 -6.29153,3.55376c-1.30295,2.2324 -1.30295,4.99342 0,7.22582c1.30295,2.2324 3.70697,3.59031 6.29153,3.55376h93.16667c2.58456,0.03655 4.98858,-1.32136 6.29153,-3.55376c1.30295,-2.2324 1.30295,-4.99342 0,-7.22582c-1.30295,-2.2324 -3.70697,-3.59031 -6.29153,-3.55376zM21.5,118.25c-5.93706,0 -10.75,4.81294 -10.75,10.75c0,5.93706 4.81294,10.75 10.75,10.75c5.93706,0 10.75,-4.81294 10.75,-10.75c0,-5.93706 -4.81294,-10.75 -10.75,-10.75zM57.33333,121.83333c-2.58456,-0.03655 -4.98858,1.32136 -6.29153,3.55376c-1.30295,2.2324 -1.30295,4.99342 0,7.22582c1.30295,2.2324 3.70697,3.59031 6.29153,3.55376h93.16667c2.58456,0.03655 4.98858,-1.32136 6.29153,-3.55376c1.30295,-2.2324 1.30295,-4.99342 0,-7.22582c-1.30295,-2.2324 -3.70697,-3.59031 -6.29153,-3.55376z"></path>
          </g>
          <g id="subtracted-icon" fill="#275cbb">
            <path
                d="M32.25,43c0,5.93706 -4.81294,10.75 -10.75,10.75c-5.93706,0 -10.75,-4.81294 -10.75,-10.75c0,-5.93706 4.81294,-10.75 10.75,-10.75c5.93706,0 10.75,4.81294 10.75,10.75zM150.5,35.83333c2.58456,-0.03655 4.98858,1.32136 6.29153,3.55376c1.30295,2.2324 1.30295,4.99342 0,7.22582c-1.30295,2.2324 -3.70697,3.59031 -6.29153,3.55376h-93.16667c-2.58456,0.03655 -4.98858,-1.32136 -6.29153,-3.55376c-1.30295,-2.2324 -1.30295,-4.99342 0,-7.22582c1.30295,-2.2324 3.70697,-3.59031 6.29153,-3.55376zM32.25,86c0,5.93706 -4.81294,10.75 -10.75,10.75c-5.93706,0 -10.75,-4.81294 -10.75,-10.75c0,-5.93706 4.81294,-10.75 10.75,-10.75c5.93706,0 10.75,4.81294 10.75,10.75zM150.5,78.83333c2.58456,-0.03655 4.98858,1.32136 6.29153,3.55376c1.30295,2.2324 1.30295,4.99342 0,7.22582c-0.12906,0.22112 -0.26892,0.43366 -0.41869,0.63712c-6.18476,-2.73207 -13.02143,-4.25003 -20.20617,-4.25003c-9.43612,0 -18.27186,2.61833 -25.81889,7.16667h-53.01445c-2.58456,0.03655 -4.98858,-1.32136 -6.29153,-3.55376c-1.30295,-2.2324 -1.30295,-4.99342 0,-7.22582c1.30295,-2.2324 3.70697,-3.59031 6.29153,-3.55376zM32.25,129c0,5.93706 -4.81294,10.75 -10.75,10.75c-5.93706,0 -10.75,-4.81294 -10.75,-10.75c0,-5.93706 4.81294,-10.75 10.75,-10.75c5.93706,0 10.75,4.81294 10.75,10.75zM57.33333,136.16667c-2.58456,0.03655 -4.98858,-1.32136 -6.29153,-3.55376c-1.30295,-2.2324 -1.30295,-4.99342 0,-7.22582c1.30295,-2.2324 3.70697,-3.59031 6.29153,-3.55376l30.7522,0c-1.35665,4.54325 -2.08553,9.35473 -2.08553,14.33333z"></path>
          </g>
          <g>
            <g id="Layer_1" fill="#275cbb">
              <path
                  d="M136.16667,100.33333c-19.78717,0 -35.83333,16.04617 -35.83333,35.83333c0,19.78717 16.04617,35.83333 35.83333,35.83333c19.78717,0 35.83333,-16.04617 35.83333,-35.83333c0,-19.78717 -16.04617,-35.83333 -35.83333,-35.83333zM150.5,143.33333h-7.16667v7.16667c0,3.956 -3.21067,7.16667 -7.16667,7.16667c-3.956,0 -7.16667,-3.21067 -7.16667,-7.16667v-7.16667h-7.16667c-3.956,0 -7.16667,-3.21067 -7.16667,-7.16667c0,-3.956 3.21067,-7.16667 7.16667,-7.16667h7.16667v-7.16667c0,-3.956 3.21067,-7.16667 7.16667,-7.16667c3.956,0 7.16667,3.21067 7.16667,7.16667v7.16667h7.16667c3.956,0 7.16667,3.21067 7.16667,7.16667c0,3.956 -3.21067,7.16667 -7.16667,7.16667z"></path>
            </g>
            <g id="Rounded" fill="#000000" opacity="0">
              <path
                  d="M86,136.16667c0,-27.66333 22.50333,-50.16667 50.16667,-50.16667c27.66333,0 50.16667,22.50333 50.16667,50.16667c0,27.66333 -22.50333,50.16667 -50.16667,50.16667c-27.66333,0 -50.16667,-22.50333 -50.16667,-50.16667z"></path>
            </g>
          </g>
        </g>
      </svg>
    </div>
    <div
        v-if="status === 'write'"
        class="right_add_list_btn pointer right_btn"
        style="margin-bottom:5px;"
        @click="handleClick($event, 'list', 'save')"
    >
      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
           v-tooltip="this.$t('status.save')"
           width="22" height="22"
           viewBox="0 0 172 172"
           style=" fill:#000000;">
        <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
           stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
           font-family="none" font-weight="none" font-size="none" text-anchor="none"
           style="mix-blend-mode: normal">
          <path d="M0,172v-172h172v172z" fill="none"></path>
          <g fill="#275cbb">
            <path
                d="M34.4,22.93333c-6.33533,0 -11.46667,5.13133 -11.46667,11.46667v103.2c0,6.33533 5.13133,11.46667 11.46667,11.46667h103.2c6.33533,0 11.46667,-5.13133 11.46667,-11.46667v-91.73333l-22.93333,-22.93333h-11.46667v34.4c0,3.1648 -2.56853,5.73333 -5.73333,5.73333h-51.6c-3.1648,0 -5.73333,-2.56853 -5.73333,-5.73333v-34.4zM91.73333,22.93333v28.66667h11.46667v-28.66667zM57.33333,91.73333h57.33333c6.33533,0 11.46667,5.13133 11.46667,11.46667v34.4h-80.26667v-34.4c0,-6.33533 5.13133,-11.46667 11.46667,-11.46667z"></path>
          </g>
        </g>
      </svg>
    </div>
    <div
        v-if="deleteDisable === false && status === 'view'"
        class="right_add_list_btn pointer right_btn"
        style="margin-bottom:5px;"
        @click="handleClick($event, 'list', 'delete')"
    >
      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
           v-tooltip="this.$t('status.delete')"
           width="21" height="21"
           viewBox="0 0 172 172"
           style=" fill:#000000;">
        <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
           stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
           font-family="none" font-weight="none" font-size="none" text-anchor="none"
           style="mix-blend-mode: normal">
          <path d="M0,172v-172h172v172z" fill="none"></path>
          <g fill="#275cbb">
            <path
                d="M71.66667,14.33333l-7.16667,7.16667h-35.83333v14.33333h7.16667v107.5c0,7.83362 6.49972,14.33333 14.33333,14.33333h57.33333v-14.33333h-57.33333v-107.5h71.66667v71.66667h14.33333v-71.66667h7.16667v-14.33333h-7.16667h-28.66667l-7.16667,-7.16667zM64.5,50.16667v78.83333h14.33333v-78.83333zM93.16667,50.16667v78.83333h14.33333v-78.83333zM128.13216,121.32943l-10.13411,10.13411l15.20117,15.20117l-15.20117,15.20117l10.13411,10.13411l15.20117,-15.20117l15.20117,15.20117l10.13411,-10.13411l-15.20117,-15.20117l15.20117,-15.20117l-10.13411,-10.13411l-15.20117,15.20117z"></path>
          </g>
        </g>
      </svg>
    </div>
    <div
        v-if="status === 'write' || status === 'view'"
        class="right_add_list_btn pointer right_btn"
        style="margin-bottom:5px;"
        @click="handleClick($event, 'list')"
    >
      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
           v-tooltip="this.$t('status.cancel')"
           width="19" height="19"
           viewBox="0 0 172 172"
           style=" fill:#000000; margin-top:1px;">
        <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
           stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
           font-family="none" font-weight="none" font-size="none" text-anchor="none"
           style="mix-blend-mode: normal">
          <path d="M0,172v-172h172v172z" fill="none"></path>
          <g id="original-icon" fill="#275cbb">
            <path
                d="M50.16667,13.4375l-50.16667,36.72917l50.16667,36.72917v-22.39583h57.33333c19.96028,0 35.83333,15.87305 35.83333,35.83333c0,19.96028 -15.87305,35.83333 -35.83333,35.83333h-107.5v28.66667h107.5c35.44141,0 64.5,-29.05859 64.5,-64.5c0,-35.4414 -29.05859,-64.5 -64.5,-64.5h-57.33333z"></path>
          </g>
        </g>
      </svg>
    </div>
  </div>
</template>
<script>
export default {
  name: 'mail-modal-btn-list',
  components: {},
  props: [
    'status',
    'deleteDisable',
    'onChange',
  ],
  data() {
    return {}
  },
  methods: {
    handleClick(event, value, type = undefined) {
      this.$emit('onChange', event, value, type);
    }
  }
}
</script>
<style lang="scss">
</style>